
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { BuscarExpedienteParams, BuscarExpedienteResponse, GenerarExpedienteParams, GenerarExpedienteResponse } from '../../interfaces/comun/ExpedienteInterface';

export const GenerarExpediente = ( params: GenerarExpedienteParams ) => {

    return new Promise<GenerarExpedienteResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Expediente/GenerarExpediente', params, token)
            .then( ({ data } : { data : GenerarExpedienteResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const BuscarExpediente = ( params: BuscarExpedienteParams ) => {

    return new Promise<BuscarExpedienteResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Expediente/BuscarExpediente', params, token)
            .then( ({ data } : { data : BuscarExpedienteResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idExpediente: 0,
                    numeroFolio: '',
                    numeroExpediente: '',
                    idTipoJuicio: 0,
                    tipoJuicio : '',
                    actor: [],
                    demandado: [],  
                    cuantia: '',
                });
            });
        }

    });

}